// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EaJU","top":"styles_top__Kiop8"};